import React from 'react';

import { Card, CardHeader, CardContent, Typography, CardProps } from '@mui/material';

interface InfoCardProps extends Omit<CardProps, 'title'> {
  title?: string | React.ReactNode;
  children: React.ReactNode;
}

/**
 * InfoCard - A simple card component for displaying static information sections
 * Used throughout the app for organizing content into visual sections
 */
export const InfoCard: React.FC<InfoCardProps> = ({ title, children, sx, ...props }) => {
  return (
    <Card {...props} sx={sx}>
      {title && (
        <CardHeader
          title={
            typeof title === 'string' ? (
              <Typography variant="h6" component="h2">
                {title}
              </Typography>
            ) : (
              title
            )
          }
          sx={{ pb: 0 }}
        />
      )}
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>{children}</CardContent>
    </Card>
  );
};
